<template>

    <div class="homepage">
        <div v-wechat-title="$route.meta.title"></div>
        <TopAdvertising></TopAdvertising>
        <div class="shuffling">
            <div class="shuffling_left">
                <ShufflingImg></ShufflingImg>
            </div>
            <div class="shuffling_reight">
                <ShufflingRight></ShufflingRight>
            </div>
        </div>
        
        <div class="project_area">
            <ProjectAtra></ProjectAtra>
            <VideoChannel></VideoChannel>
            <ProjectColumn></ProjectColumn>
            <PictureOfPuyang></PictureOfPuyang>
            <Advertising></Advertising>
        </div>
    <!-- <FriendshipLink></FriendshipLink> -->
    </div>
</template>
<script>
import Bus from '@/Bus'

import ShufflingImg from '@/components/homepage/components/shufflingImg.vue'
import ShufflingRight from '@/components/homepage/components/shufflingRight.vue'
// 顶部广告
import TopAdvertising from '@/components/homepage/components/topAdvertising'
// 栏目模块
import ProjectAtra from '@/components/homepage/components/projectAtra'
import VideoChannel from '@/components/homepage/components/videoChannel'
import ProjectColumn from '@/components/homepage/components/projectColumn'
import PictureOfPuyang from '@/components/homepage/components/pictureOfPuyang'
import Advertising from '@/components/homepage/components/advertising'

// 底部
import FriendshipLink from '@/components/homepage/components/friendshipLink'

export default {
    data(){
        return {
            scroll:'',
        }
    },
    components:{
        ShufflingImg,
        ShufflingRight,
        ProjectAtra,
        VideoChannel,
        ProjectColumn,
        PictureOfPuyang,
        Advertising,
        // 顶部广告
        TopAdvertising,
        FriendshipLink,
        loadingSetUpIf:true
    },
    created(){
        Bus.$emit('botLink', true );
        // Bus.$on("loadingSetUp", val => {
        //     this.loadingSetUpIf = val
        // });
    },
    mounted() {
        // console.log(window.location.href,'==================')
        // if(!this.loadingSetUpIf){
        //     window.addEventListener('scroll', this.scrollTop)
        // }
       
    },
    methods:{
        // scrollTop(){
        //     this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
        //     console.log(this.scroll)
        // },
    }
}
</script>
<style lang="">
.homepage{
    margin-top:20px;
    width:1200px;
    margin:0 auto;
    /* -moz-box-shadow:0 0 10px rgb(239, 239, 240);
    -webkit-box-shadow:0 0 10px rgb(206, 206, 209);
    box-shadow:0 0 10px rgb(184, 184, 187); */
    background:#ffffff;
}
.shuffling{
    display:flex;
}
.shuffling_left{
    height:392px;
    width:768px;
    display:inline-block;
}
.shuffling_reight{
    display:inline-block;
    width:377px;
    height:392px;
    margin-left:47px;
}



</style>


// WEBPACK FOOTER //
// src/components/homepage/index.vue